"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wechatAuth = exports.getWechatConfig = void 0;
var getWechatConfig = exports.getWechatConfig = function getWechatConfig() {
  return Promise.resolve({});
};
var wechatAuth = exports.wechatAuth = function wechatAuth() {
  return Promise.resolve();
};